import React, { memo } from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { ResultsDropdown } from "./ResultsDropdown";
import { SearchInputProps } from "./types";
import Translations from "@translate/components/Portfolio/Search/SearchInput";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

/**
 * SearchInput
 * - 桌面端搜索输入组件（激活态）
 * - 包含输入框、取消按钮和下拉结果
 * - 支持淡出动画效果
 */
export const SearchInput: React.FC<SearchInputProps> = memo(
  ({
    keywords,
    onChange,
    onCancel,
    inputRef,
    closing,
    showDropdown,
    results,
    loading = false,
    onSelect,
    hasMore,
    onLoadMore,
  }) => (
    <div
      className="relative w-[252px]"
      data-testid="portfolio-tab-search-active"
    >
      <div
        className={cn(
          "flex items-center gap-2 transition-opacity",
          closing ? "opacity-0" : "opacity-100",
        )}
        style={{ transitionDuration: "200ms" }}
      >
        <div className="flex items-center h-9 px-3 flex-1">
          <Icon name="search" size={16} className="text-content_tertiary" />
          <input
            ref={inputRef}
            placeholder={I18n.t("Search")}
            aria-label="Search"
            className={cn(
              "ml-2 flex-1 h-full body_s text-content_primary caret-content_brand_primary bg-transparent border-0 outline-none",
              "placeholder:text-content_tertiary/60 focus:outline-none focus:ring-0",
            )}
            value={keywords}
            onChange={onChange}
          />
        </div>
        <button
          aria-label="Search Input"
          data-openreplay-label={`Search Input Button | ${I18n.t("Cancel")}`}
          id="btn-search-input"
          type="button"
          onClick={onCancel}
          className="button_s text-content_tertiary hover:text-content_primary"
        >
          {I18n.t("Cancel")}
        </button>
      </div>

      {/* 下拉容器：当存在输入时展示；loading 使用骨架屏；空结果显示公共 EmptyState */}
      {keywords && showDropdown && (
        <ResultsDropdown
          results={results}
          loading={loading}
          onSelect={onSelect}
          hasMore={hasMore}
          onLoadMore={onLoadMore}
        />
      )}
    </div>
  ),
);

SearchInput.displayName = "SearchInput";
